require.context('../../../ui/img/', true, /\.(gif|png|jpe?g|svg)$/i);

window['renderMenu'] = function() {

    var gamesToRender = getAvailableGames();
    var element = document.querySelector('#sidebar');
    var html = '';

    gamesToRender.forEach((game) => {
        return html +=
            `<li>
                <a class="${window.location.href.replace(/index.html?.*/, '') == BASE_URL + GAMES[game].url + '/'  ? 'active' : ''}"  
                href="javascript: void(0)" onclick="redirectToUrl('${BASE_URL + GAMES[game].url}')">` +
            `<img alt="${GAMES[game].url}"  src='../shared/img/${GAMES[game].url}.png' /><span>${GAMES[game].name}</span></a>` +
            `</li>`;
    });

    element.innerHTML = html;
}

/**
 * Gets game numbers as array from api response.
 * @return array
 */
function getAvailableGames() {
    var responseGames = window['menu'].split('|');
    var availableGames = responseGames.filter(function(val) {
        return Object.keys(GAMES).indexOf(val) != -1;
    });
    return availableGames;
}


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/js/menu.js
// module id = 1999
// module chunks = 4